<template>
  <div>

    <div class="center big-padding">
      Souhaitez-vous désactiver le maitrise <strong>{{maitrise.nom}} {{maitrise.prenom}} </strong> - <strong>{{maitrise.arrondissement_id | arrondissementName}}</strong> ? <br>Ce compte ne pourra alors plus accéder à l'application.
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Désactiver
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store'

export default {
  props: [
    'maitrise',
  ],
  methods: {
    confirm: function () {
      this.$store.dispatch('deactivateMaitrise', this.maitrise)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// MaitrisesDelete.vue?05f862fc